<template>
  <div class="feedback-question">
    <div class="index">{{questionIndex}}</div>
    <FeedbackQuestionFulltext v-if="question.answerType === 'fulltext'" :question="question" :answer.sync="answer_">
      <template v-for="slot in possibleChildSlotsFor('FullText')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </FeedbackQuestionFulltext>
    <FeedbackQuestionNumberRange v-if="question.answerType === 'numberRange'" :question="question" :answer.sync="answer_">
      <template v-for="slot in possibleChildSlotsFor('NumberRange')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </FeedbackQuestionNumberRange>
  </div>
</template>

<script>
import FeedbackQuestionFulltext from './QuestionFulltext.vue'
import FeedbackQuestionNumberRange from './QuestionNumberRange.vue'
import syncProperty from '../../../../mixins/syncProperty'
import slotProxy from '../../../../mixins/slotProxy'
export default {
  name: 'FeedbackQuestion',
  mixins: [
    syncProperty('answer', 'answer_'),
    slotProxy()
  ],
  components: { FeedbackQuestionNumberRange, FeedbackQuestionFulltext },
  props: {
    questionIndex: {
      type: Number,
      default: 1
    },
    question: {
      type: Object
    }
  }
}
</script>
